import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  FormHelperText 
} from '@mui/material';
import { User } from '../../types';

interface UserSelectProps {
  users: User[];
  value: number | '';
  onChange: (userId: number | '') => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  label?: string;
  helperText?: string;
}

/**
 * A reusable component for selecting a user from a dropdown list
 */
const UserSelect: React.FC<UserSelectProps> = ({
  users,
  value,
  onChange,
  error,
  disabled = false,
  required = true,
  label = 'User',
  helperText
}) => {
  return (
    <FormControl fullWidth error={!!error} disabled={disabled} required={required}>
      <InputLabel id="user-select-label">{label}</InputLabel>
      <Select
        labelId="user-select-label"
        value={value}
        label={label}
        onChange={(e) => {
          const selectedValue = e.target.value;
          onChange(selectedValue === '' ? '' : Number(selectedValue));
        }}
      >
        <MenuItem value=""><em>Select a user</em></MenuItem>
        {users.map((user) => (
          <MenuItem key={user.id} value={user.id}>
            {user.name} ({user.email})
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
      {!error && helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default UserSelect;
